import React, { useEffect } from 'react';
import { useStore } from '../../store/store';
import { getCableConsumer, disconnectCableConsumer } from '../../utils/cable';
import { message } from 'antd';

const selector = (state) => ({
  fetchDatas: state.fetchDatas,
  getTemplates: state.getTemplates,
  currentDocument: state.currentDocument,
  proposals: state.proposals,
  isAdmin: state.isAdmin,
  handlePdfReponse: state.handlePdfReponse,
  setLoaderPdfToImage: state.setLoaderPdfToImage,
  removePdfContainer: state.removePdfContainer,
  addContainerPdfToImage: state.addContainerPdfToImage,
  user: state.user,
  currentProposal: state.currentProposal,
});

export const Providers = ({ children }) => {
  const { user, currentDocument, currentProposal } = useStore(selector);

  const { fetchDatas, getTemplates, handlePdfReponse, addContainerPdfToImage, setLoaderPdfToImage, removePdfContainer } =
    useStore(selector);

  useEffect(() => {
    const cable = getCableConsumer();
    if (cable) {
      const channel = cable.subscriptions.create({
        channel: "EditorsChannel",
      },
        {
          received: (data) => {
            if ("image_url" in data) {
              addContainerPdfToImage({ data })
            }
            if (data?.end_socket === true) {
              setLoaderPdfToImage(false);
              removePdfContainer();
              // Fermer la notification de traitement en cours
              message.destroy();
            }
            if (data?.pages || data?.pdf_url || data?.pdf_error) {
              handlePdfReponse(data)
            }
            // Screenshots de planning prêts (worker terminé) -> re-fetch les
            // tableaux planning ET swap les images des sections récursives.
            if (data?.planning_screenshots_ready) {
              useStore.getState().refreshPlanningScreenshotTables()
              useStore.getState().refreshRecursivePlanningImages()
            }
          }
        });

      return () => {
        if (channel) {
          channel.unsubscribe()
        }
        disconnectCableConsumer()
      };
    }
  }, [handlePdfReponse])

  // En parallèle : la liste des modèles ne dépend que de currentDocument, posé
  // depuis l'URL à la création du store. Attendre fetchDatas (le document
  // entier) retardait d'autant la liste des modèles.
  useEffect(() => {
    fetchDatas();
    getTemplates();
  }, [getTemplates, fetchDatas]);

  return null;
};

export default Providers;
